import { render, staticRenderFns } from "./LocationLabSettings.vue?vue&type=template&id=40763131&"
import script from "./LocationLabSettings.vue?vue&type=script&lang=js&"
export * from "./LocationLabSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports